export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

export const isIOS = () => {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent) ||
    (navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform));
};

export const isAndroid = () => {
  return /Android/i.test(navigator.userAgent);
};

export const isTesla = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const platform = navigator.platform ? navigator.platform.toLowerCase() : '';
  
  // Détection spécifique Tesla Browser
  return userAgent.includes('tesla') || 
         userAgent.includes('teslabrowser') ||
         platform.includes('tesla') ||
         // Tesla utilise souvent QtWebEngine
         (userAgent.includes('qtwebengine') && userAgent.includes('linux')) ||
         // Détection par résolution d'écran typique Tesla (17" touchscreen)
         (window.screen && window.screen.width === 1920 && window.screen.height === 1200);
};